import { c as _c } from "react/compiler-runtime";
import { ReserveCommentsFilterItem } from "@website/widget/reserve-comment-popup-scroll/reserve-comment-filter/reserve-comment-filter-item";
import { ReserveCommentFilterTypes } from "@website/widget/reserve-comment-popup-scroll/reserve-comment-filter/reserve-comment-filter.types";
import { ReserveCommentsSort } from "@website/widget/reserve-comment-popup-scroll/reserve-comment-sort/reserve-comment-sort";
import isEmpty from "lodash-es/isEmpty";
import { useRouter } from "next/router";
export const ReserveCommentsFilter = t0 => {
  const $ = _c(15);
  const {
    onLoadFilter,
    filters,
    isInsideDetail
  } = t0;
  const router = useRouter();
  let t1;
  if ($[0] !== filters || $[1] !== isInsideDetail || $[2] !== onLoadFilter || $[3] !== router?.query?.filter_attitude) {
    t1 = !isEmpty(filters) && <ReserveCommentsFilterItem filterName={{
      fa: `${router?.query?.filter_attitude === "all" ? "\u0647\u0645\u0647 \u0646\u0638\u0631\u0627\u062A" : router?.query?.filter_attitude === "positive" ? "\u0646\u0638\u0631\u0627\u062A \u0645\u062B\u0628\u062A" : router?.query?.filter_attitude === "negative" ? "\u0646\u0638\u0631\u0627\u062A \u0645\u0646\u0641\u06CC" : "\u0646\u0648\u0639 \u0646\u0638\u0631\u0627\u062A"}`,
      en: `${Object.keys(filters)[0]}`
    }} isInsideDetail={isInsideDetail} onLoadFilter={onLoadFilter} radioItems={[{
      label: "\u0647\u0645\u0647 \u0646\u0638\u0631\u0627\u062A",
      value: "all"
    }, {
      label: "\u0646\u0638\u0631\u0627\u062A \u0645\u062B\u0628\u062A",
      value: "positive"
    }, {
      label: "\u0646\u0638\u0631\u0627\u062A \u0645\u0646\u0641\u06CC",
      value: "negative"
    }]} startIconName="stars" />;
    $[0] = filters;
    $[1] = isInsideDetail;
    $[2] = onLoadFilter;
    $[3] = router?.query?.filter_attitude;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const t2 = `${router?.query?.order_by === "recommended" ? "\u067E\u06CC\u0634\u0646\u0647\u0627\u062F\u06CC" : router?.query?.order_by === "newest" ? "\u062C\u062F\u06CC\u062F\u062A\u0631\u06CC\u0646" : "\u0645\u0631\u062A\u0628\u200C\u0633\u0627\u0632\u06CC"}`;
  let t3;
  if ($[5] !== t2) {
    t3 = {
      fa: t2,
      en: ""
    };
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = [{
      label: "\u067E\u06CC\u0634\u0646\u0647\u0627\u062F\u06CC",
      value: "recommended"
    }, {
      label: "\u062C\u062F\u06CC\u062F\u062A\u0631\u06CC\u0646",
      value: "newest"
    }];
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== isInsideDetail || $[9] !== onLoadFilter || $[10] !== t3) {
    t5 = <ReserveCommentsSort filterName={t3} isInsideDetail={isInsideDetail} onLoadFilter={onLoadFilter} radioItems={t4} startIconName="sort" />;
    $[8] = isInsideDetail;
    $[9] = onLoadFilter;
    $[10] = t3;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t1 || $[13] !== t5) {
    t6 = <div className="flex flex-row items-center justify-between gap-4">{t1}{t5}</div>;
    $[12] = t1;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  return t6;
};